module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker43-api.relevant-digital.com/"}};